module.exports = __webpack_public_path__ + "static/media/hardPicOne.68d671db.jpg";